import React, { useState } from 'react';

const CompanyForm = ({ onAnalyze, loading }) => {
  const [companyDescription, setCompanyDescription] = useState('');
  const [subreddits, setSubreddits] = useState([]);
  const [newSubreddit, setNewSubreddit] = useState('');

  const handleAddSubreddit = () => {
    if (newSubreddit.trim() && !subreddits.includes(newSubreddit.trim())) {
      setSubreddits([...subreddits, newSubreddit.trim()]);
      setNewSubreddit('');
    }
  };

  const handleRemoveSubreddit = (subredditToRemove) => {
    setSubreddits(subreddits.filter(sub => sub !== subredditToRemove));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddSubreddit();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (companyDescription.trim() && subreddits.length > 0) {
      onAnalyze(companyDescription.trim(), subreddits);
    }
  };

  return (
    <div className="dark-card rounded-lg p-8 shadow-lg">
      <h2 className="text-2xl font-bold mb-6 dark-text">Setup Your Brand Analysis</h2>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium dark-text mb-2">
            Company Description
          </label>
          <textarea
            value={companyDescription}
            onChange={(e) => setCompanyDescription(e.target.value)}
            placeholder="Describe your company, products, or services in detail. The more specific, the better the analysis will be."
            rows={4}
            className="w-full px-4 py-3 bg-gray-700 border-2 border-gray-600 rounded-lg focus:border-purple-400 focus:outline-none dark-text placeholder-gray-400 resize-none"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium dark-text mb-2">
            Subreddits to Monitor
          </label>
          <div className="flex gap-2 mb-2">
            <input
              type="text"
              value={newSubreddit}
              onChange={(e) => setNewSubreddit(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter subreddit name (without r/)"
              className="flex-1 px-4 py-3 bg-gray-700 border-2 border-gray-600 rounded-lg focus:border-purple-400 focus:outline-none dark-text placeholder-gray-400"
            />
            <button 
              type="button" 
              onClick={handleAddSubreddit}
              className="gradient-bg text-white px-4 py-3 rounded-lg font-medium hover:shadow-lg transition-all duration-200"
            >
              Add
            </button>
          </div>
          
          {subreddits.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {subreddits.map((subreddit, index) => (
                <div key={index} className="bg-gray-700 px-3 py-1 rounded-full text-sm flex items-center gap-2 dark-text">
                  r/{subreddit}
                  <button
                    type="button"
                    onClick={() => handleRemoveSubreddit(subreddit)}
                    className="text-gray-400 hover:text-gray-200 font-bold text-lg leading-none"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <button 
          type="submit" 
          disabled={loading || !companyDescription.trim() || subreddits.length === 0}
          className="w-full gradient-bg text-white py-4 rounded-lg font-medium text-lg disabled:opacity-60 disabled:cursor-not-allowed hover:shadow-lg transition-all duration-200"
        >
          {loading ? 'Analyzing...' : 'Find Engagement Opportunities'}
        </button>
      </form>
      
      <div className="mt-8 p-4 bg-gray-700 rounded-lg">
        <h4 className="font-medium dark-text mb-2">How it works:</h4>
        <ol className="text-sm dark-text-muted space-y-1 pl-4">
          <li>1. We'll fetch posts from the last week in your specified subreddits</li>
          <li>2. Filter posts based on engagement level (upvotes, comments, recency)</li>
          <li>3. Use AI to analyze which posts are relevant to your company</li>
          <li>4. Classify the type of engagement opportunity for each post</li>
          <li>5. Show you the best opportunities with direct links to Reddit</li>
        </ol>
      </div>
    </div>
  );
};

export default CompanyForm; 